<template>
  <div id="dependent-data-form">
    <header class="panel__header mt-2 mb-4" v-if="hasTitle">
      <h2 class="panel__title">GAMEBOX:</h2>
    </header>

    <div class="row">
      <div class="col-12 col-sm-12">
        <div id="accordion" class="panel__content">
          <div
            v-for="(planodepentente, indexPlano) in dependentes"
            :key="indexPlano"
            class="card mb-4"
            style="border: none"
          >
            <div
              id="headingOne"
            >
              <div :class="{'card-header': true, 'bg-primary': !acquired(planodepentente), 'bg-grey': acquired(planodepentente)}" style="height: unset !important;">
                <div class="row">
                  <div class="col-6 col-md-3 d-flex align-items-center justify-content-center flex-column">
                    <img class="d-none d-md-block" style="width: 150px; border-radius: 12px !important; box-shadow: 0 8px 6px -6px #000;" :src="planodepentente.card_front">
                    <img class="d-block d-md-none" style="width: 125px; border-radius: 12px !important; box-shadow: 0 8px 6px -6px #000;" :src="planodepentente.card_front">
                  </div>
                  <div class="col-6 col-md-5 d-flex justify-content-center flex-column">
                    <h5 style="margin-bottom: 4px" class="text-light"> Gamebox </h5>
                    <h3 style="margin-bottom: 4px" class="text-light"> {{ planodepentente.nome_display }} </h3>
                    <h5 class="text-light" style="margin-bottom: 0px">
                      Por {{ planodepentente.valor | currency }}
                    </h5>
                  </div>
                  <div class="col-12 col-md-4 mt-2 mt-0-md d-flex align-items-end justify-content-center flex-column">
                    <button
                      class="btn btn-outline-white dep-btn-block"
                      style="min-width: 140px;"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#dependent-plan-' + planodepentente.id"
                      type="button"
                    >
                      {{ acquired(planodepentente) ? "Contratado" : "Aderir"}}
                    </button>
                  </div>
                </div>
              </div>

              <div
                :id="'dependent-plan-' + planodepentente.id"
                class="collapse card-body"
                aria-labelledby="headingOne"
                data-bs-parent="#accordion"
                style="border: 1px solid #ccc;"
              >
                <div>
                  <div>
                    <small v-html="descricaoPlaDep(planodepentente)"></small>
                  </div>

                  <div
                    v-for="(dependente, index) in planodepentente.dependentes"
                    style="padding: 0px"
                    :key="index"
                  >
                    <div
                      :id="`div` + planodepentente.id + index"
                      v-bind:style="{ display: displayDep(index) }"
                    >
                      <div class="row" v-if="planodepentente.tipo == 'X'">
                        <p class="col-12">
                          <input
                            data-vv-as="Nome Completo"
                            v-validate="'required|alpha_spaces'"
                            :class="{
                              'is-invalid': errors.has(
                                'nomeCompleto_' + indexPlano + '_' + index
                              ),
                            }"
                            :name="'nomeCompleto_' + indexPlano + '_' + index"
                            type="text"
                            class="form-control"
                            v-model="dependentes[indexPlano].dependentes[index].nomeCompleto"
                            placeholder="Nome Completo: João Paulo da Silva"
                            value=""
                          />

                          <span class="invalid-feedback">
                            {{
                              errors.first(
                                "nomeCompleto_" + indexPlano + "_" + index
                              )
                            }}
                          </span>
                        </p>
                      </div>

                      <div class="row" v-if="planodepentente.tipo != 'X'">
                        <p class="col-12 col-sm-7">
                          <input
                            data-vv-as="Nome Completo"
                            v-validate="'required|alpha_spaces'"
                            :class="{
                              'is-invalid': errors.has(
                                'nomeCompleto_' + indexPlano + '_' + index
                              ),
                            }"
                            :name="'nomeCompleto_' + indexPlano + '_' + index"
                            type="text"
                            class="form-control"
                            v-model="dependentes[indexPlano].dependentes[index].nomeCompleto"
                            placeholder="Nome Completo: João Paulo da Silva"
                            value=""
                          />

                          <span class="invalid-feedback">
                            {{
                              errors.first(
                                "nomeCompleto_" + indexPlano + "_" + index
                              )
                            }}
                          </span>
                        </p>
                        <p class="col-12 col-sm-5">
                          <input
                            data-vv-as="E-mail"
                            :class="{
                              'is-invalid': errors.has(
                                'email_' + indexPlano + '_' + index
                              ),
                            }"
                            :name="'email_' + indexPlano + '_' + index"
                            v-validate="'email'"
                            type="email"
                            class="form-control"
                            v-model="
                              dependentes[indexPlano].dependentes[index].email
                            "
                            placeholder="E-mail: seuemail@xxxx.com.br"
                            value=""
                          />

                          <span class="invalid-feedback">
                            {{
                              errors.first("email_" + indexPlano + "_" + index)
                            }}
                          </span>
                        </p>
                      </div>

                      <div class="row" v-if="planodepentente.tipo != 'X'">
                        <p class="col-12 col-sm-4">
                          <masked-input
                            data-vv-as="NIF"
                            :class="{
                              'is-invalid': errors.has(
                                'nif_' + indexPlano + '_' + index
                              ),
                            }"
                            :name="'nif_' + indexPlano + '_' + index"
                            type="text"
                            class="form-control"
                            v-model="
                              dependentes[indexPlano].dependentes[index].cpf
                            "
                            :mask="[/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/]"
                            v-on:keydown.delete="onDeleteMask"
                            :guide="false"
                            placeholder="NIF: 000000000"
                          >
                          </masked-input>

                          <span class="invalid-feedback">
                            {{
                              errors.first("nif_" + indexPlano + "_" + index)
                            }}
                          </span>
                        </p>
                        <p class="col-12 col-sm-4">
                          <masked-input
                            v-on:keyup="
                              dep_idade(
                                dependentes[indexPlano].dependentes[index].dataNascimento,
                                dependentes[indexPlano].idade_inicial,
                                dependentes[indexPlano].idade_final
                              )
                            "
                            :v-validate="{
                              required: true,
                              datanasc: true,
                              idadecompat: dt_dep_error,
                            }"
                            type="text"
                            :name="'dataNascimento_' + indexPlano + '_' + index"
                            class="form-control"
                            :class="{
                              'is-invalid':
                                check_idade(
                                  dependentes[indexPlano].dependentes[index].dataNascimento,
                                  dependentes[indexPlano].idade_inicial,
                                  dependentes[indexPlano].idade_final
                                ) +
                                errors.has(
                                  'dataNascimento_' + indexPlano + '_' + index
                                ),
                            }"
                            v-model="dependentes[indexPlano].dependentes[index].dataNascimento"
                            :mask="[/\d/,/\d/,'/',/\d/,/\d/,'/',/\d/,/\d/,/\d/,/\d/]"
                            v-on:keydown.delete="onDeleteMask"
                            :guide="false"
                            placeholder="Data de Nascimento: DD/MM/AAAA"
                          >
                          </masked-input>

                          <span class="invalid-feedback">
                            {{ errors.first("dataNascimento_" + indexPlano + "_" + index) }}
                          </span>
                        </p>

                        <p class="col-12 col-sm-4">
                          <select
                            data-vv-as="Sexo"
                            :class="{
                              'is-invalid': errors.has(
                                'sexo_' + indexPlano + '_' + index
                              ),
                            }"
                            :name="'sexo_' + indexPlano + '_' + index"
                            class="form-select"
                            v-model="dependentes[indexPlano].dependentes[index].sexo"
                          >
                            <option value="" selected disabled>Sexo:</option>
                            <option value="M">Masculino</option>
                            <option value="F">Feminino</option>
                          </select>
                          <span class="invalid-feedback">
                            {{ errors.first("sexo_" + indexPlano + "_" + index) }}
                          </span>
                        </p>
                      </div>

                      <div
                        :id="'btnAddDep' + planodepentente.id + index"
                        v-if="index < planodepentente.dependentes.length - 1"
                        style="text-align: right; margin-top: 15px"
                      >
                        <button
                          v-on:click="
                            showNextDep(
                              'div' + planodepentente.id + (index + 1),
                              'btnAddDep' + planodepentente.id + index
                            )
                          "
                          type="button"
                          class="btn btn-primary"
                          style="border-radius: 50px"
                        >
                          <!-- data-bs-dismiss="modal" -->
                          <i class="fas fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-alert
          variant="danger"
          dismissible
          :show="error.show"
          v-model="error.show"
        >
          {{ error.text }}
        </b-alert>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .card-flip-web,
  .card-flip-mobile{
    padding: 0;
    position: relative;
    margin: 0 0 30px 0;
  }

  @media (max-aspect-ratio: 1/1) {
    .dep-btn-block {
      width: 100%;
    }
  }
</style>

<script>
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      plusQuotaCount: 0,
      // TODO: Refactor
      dt_dep_error: true,
      error: {
        show: false,
        text: '',
      },
    }
  },
  mounted() {
    console.log(this)
  },
  props: {
    user: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    plano: {
      required: true,
      type: Object
    },
    dependentes: {
      required: true,
      type: Array
    },
    hasTitle: {
      required: false,
      type: Boolean,
      default: true,
    }
  },
  methods: {
    // TODO: refactor
    descricaoPlaDep(planodepentente){
      if(planodepentente.detalhe_desc){
        return planodepentente.detalhe_desc
      }

      return 'A partir de: R$ ' + planodepentente.valor + '.'
    },
    // Todo: refactor
    displayDep(index) {
      if (index > 0) {
        return 'none'
      }

      return 'block'
    },
    // TODO: refactor
    dep_idade(val, ini, end){
      let ldata = val.split('/')

      var i
      var now = new Date
      var liberado = true
      for (i = (now.getFullYear() - end); i <= now.getFullYear(); i++) { 
        if(ldata[2] == i){
          liberado = false
        }
      }

      this.dt_dep_error = liberado
    },
    // TODO: Refactor
    check_idade(val, ini, end){
      if (val == '') {
        return false
      }

      let ldata  = val.split('/')

      var i
      var now = new Date
      for (i = (now.getFullYear() - end); i <= now.getFullYear(); i++) { 
        if(ldata[2] == i){
          return false
        }
      }
      return true
    },
    // TODO: Refactor
    showNextDep(idDep, btn){
      $('#'+btn).hide();
      $('#'+idDep).show();
    },
    async submit() {
      try {
        let inputs = document.querySelectorAll("input")
      
        let val = []
        inputs.forEach(input => {
          if (input.name.match(/(dataNascimento)\_\d\_\d+/g) && input.value != "") {
            val.push(input.name)
          }
        })

        $(".wizard-footer-right").hide();

        if (!await this.$validator.validateAll(val)) {
          throw new Error('Preencha os campos corretamente.')
        }

        this.storeDependents()
      } catch (error) {
        $("html, body").animate({scrollTop:$("#cadastroSocio").offset().top - 10}, 500, 'swing')
        return false
      }
    },
    setValidationError(field, msg) {
      this.$validator.errors.add({
        field: field,
        msg: msg
      })
    },
    // Não faço a menor ideia do que isso faz, originalmente foi escrito pelo David Petter.
    onDeleteMask(event) {
      let value = event.target.value; 
      let char = value[value.length-1];
      if (isNaN(parseInt(char)) || char == ' ') { event.target.value = value.substring(0, value.length-1); }
    },
    acquired(plan) {
      for (const dep of plan.dependentes) {
        if (dep.id !== null) {
          return true
        }
      }

      return false
    },
    async storeDependents() {
      this.error.show = false
      this.$validator.errors.clear()

      try {
        const response = await axios.post('/cadastro/dependentes', {
          userId: this.user.id,
          dependentes: this.dependentes
        })

        const { data } = response

        if(data.error) {
          $("html, body").animate({scrollTop:$("#cadastroSocio").offset().top - 10}, 500, 'swing');

          if(typeof data.message == "string") {
            this.error.show = true
            this.error.text = data.message
          } else {
            $.each(data.message, function( indexPlano, valuePlanp ) {
              $.each(valuePlanp, function( index, fields) {
                $.each(fields, function( campo, mensagem) {
                  const field = campo + '_' + indexPlano + '_' + index;
                  this.setValidationError(field, mensagem)
                })
              })
            })
          }

          return false
        } else {
          if(response.data.login) {
            window.location.href = "/login";
            return true
          }
        }
      } catch (error) {
        $( ".wizard-footer-right" ).show();

        this.error.show = true

        if (typeof error.response.data.errors.email[0] !== 'undefined') {
          this.error.text = error.response.data.errors.email[0]
        } else {
          this.error.text = "Erro interno, tente novamente mais tarde."
        }

        return false
      }
    }
  }
})
</script>